export default __webpack_public_path__ + "static/char-s-53-ko-9d9902d74b8f9a0693c37584c74f922f.webp";